import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "loadMoreButton", "hiddenCount"]
  static values = {
    batchSize: { type: Number, default: 5 },
  }

  connect() {
    this.updateLoadMore()
  }

  loadMore(event) {
    event.preventDefault()

    const hiddenItems = this.hiddenItems
    hiddenItems.slice(-this.batchSizeValue).forEach((item) => {
      item.classList.remove("is-hidden")
    })

    this.updateLoadMore()
  }

  updateLoadMore() {
    if (!this.hasLoadMoreButtonTarget) return

    const hiddenCount = this.hiddenItems.length

    if (this.hasHiddenCountTarget) {
      this.hiddenCountTarget.textContent = hiddenCount
    }

    this.loadMoreButtonTarget.hidden = hiddenCount === 0
  }

  get hiddenItems() {
    return this.itemTargets.filter((item) => item.classList.contains("is-hidden"))
  }
}
